import React, {useEffect, useState} from 'react';
import DashboardLayout from "../../layouts/Dashboard";
import {GENERAL_ROUTE, CONTRACT_REQUESTS_ROUTE} from "../../routes/const";
import BreadcrumbsShared from "../../components/Shared/BreadcrumbsShared";
import {useDispatch, useSelector} from "react-redux";
import {LOADING_FALSE, LOADING_TRUE} from "../../redux/constants/genericConstants";
import {getServicesSchedule} from "../../redux/actions/service/serviceActions";
import GeneralTable from "../../components/General/GeneralTable";
import {Card, CardActions, CardContent, Paper, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress} from "@mui/material";
import Button from "@mui/material/Button";
import ShopIcon from '@mui/icons-material/Shop';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {changeBasket, clearBasket} from "../../redux/actions/basket/basketActions";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {confirmDialog} from "../../components/Popups/message/PopupDelete";
import ClientLayout from "../../layouts/ClientLayout";
import PopupPreliminarilyContract from "../../components/Contract/PopupPreliminarilyContract";
import RecommendIcon from '@mui/icons-material/Recommend';
import {addClientRequest} from "../../redux/actions/clientRequest/clientRequestActions";
import {showSuccessSnackbar} from "../../redux/actions/userActions";
import {geoObjectCRUD, filialCRUD} from "../../http/CRUD";
import {$authHost} from "../../http";
import {getFilial} from "../../redux/actions/filial/filialActions";
import {useHistory} from "react-router-dom";
import {TextField, MenuItem} from "@mui/material";
import LocationOnIcon from '@mui/icons-material/LocationOn';

function Basket(props) {
    const [open, setOpen] = useState(false)
    const handleClose = () => {
        setOpen(false)
    }
    const [notificationOpen, setNotificationOpen] = useState(false)
    const [notificationMessage, setNotificationMessage] = useState('')
    const [notificationSeverity, setNotificationSeverity] = useState('success')
    
    const userLogin = useSelector((state) => state.user);
    const {isClient, filialUser} = userLogin;
    const {profile} = useSelector((state) => state.profile);
    const {basket} = useSelector((state) => state.basket)
    const [basketLocal, setBasketLocal] = useState([])
    const [price, setPrice] = useState(0)
    const addressId = profile?.type?.id === 1 ? profile?.client?.person?.addressId : profile?.client?.legalPerson?.addressId
    const {servicesSchedule} = useSelector((state) => state.service);
    const dispatch = useDispatch()
    const history = useHistory()
    const [filials, setFilials] = useState([])
    const [selectedFilial, setSelectedFilial] = useState('')

    // Состояния для диалога подтверждения региона
    const [regionDialogOpen, setRegionDialogOpen] = useState(false)
    const [regionName, setRegionName] = useState('')   // Область/Регион (родитель)
    const [cityName, setCityName] = useState('')       // Город (addressId)
    const [geoFilialId, setGeoFilialId] = useState(null) // filialId из гео-объекта пользователя
    const [geoFilialName, setGeoFilialName] = useState('') // название филиала из гео-объекта
    const [regionLoading, setRegionLoading] = useState(true)
    const [regionConfirmed, setRegionConfirmed] = useState(false)

    useEffect(() => {
        (async function () {
            dispatch({type: LOADING_TRUE})
            await dispatch(getServicesSchedule(1, 100))
            // Загружаем список филиалов (пробуем несколько способов)
            let filialsLoaded = []
            
            // Способ 1: стандартный CRUD (для админов/маркетологов)
            try {
                const res = await filialCRUD.search({paging: {skip: 0, take: 1000}})
                if (res?.result?.length) {
                    filialsLoaded = res.result
                }
            } catch (e) {
                console.error("filialCRUD.search не доступен:", e)
            }

            // Способ 2: клиентский endpoint (если стандартный не вернул данных)
            if (filialsLoaded.length === 0) {
                try {
                    const {data} = await $authHost.get('api/v1/area/client/filial')
                    if (Array.isArray(data) && data.length > 0) {
                        filialsLoaded = data
                    } else if (data?.result?.length > 0) {
                        filialsLoaded = data.result
                    }
                } catch (e) {
                    console.error("Клиентский endpoint филиалов не доступен:", e)
                }
            }

            // Способ 3: через Redux action getFilial
            if (filialsLoaded.length === 0) {
                try {
                    const res = await dispatch(getFilial(1, 10000, undefined, true))
                    if (res?.length) {
                        filialsLoaded = res
                    }
                } catch (e) {
                    console.error("getFilial action не доступен:", e)
                }
            }

            // Убираем из списка: пустые/мусорные имена, РГУ, Комитет
            filialsLoaded = filialsLoaded.filter(f => {
                const name = (f.name || '').trim()
                if (!name || name.replace(/[^a-zA-Zа-яА-ЯёЁ0-9]/g, '').length < 3) return false // пустое или мусорное имя (запятые ",," и т.д.)
                if (name.toLowerCase().includes('ргу')) return false // РГУ
                if (name.toLowerCase().startsWith('комитет')) return false // Комитет
                return true
            })
            setFilials(filialsLoaded)

            // Загружаем название города и региона пользователя
            try {
                if (addressId) {
                    const geoData = await geoObjectCRUD.get(addressId)
                    if (geoData?.name) {
                        setCityName(geoData.name)
                    }
                    // Сохраняем filialId из гео-объекта
                    let foundFilialId = null
                    if (geoData?.filialId) {
                        foundFilialId = geoData.filialId
                    }
                    // Загружаем родительский объект (регион/область)
                    if (geoData?.parentId) {
                        const parentGeo = await geoObjectCRUD.get(geoData.parentId)
                        if (parentGeo?.name) {
                            setRegionName(parentGeo.name)
                        }
                        // Если у текущего гео-объекта нет filialId, проверяем родительский
                        if (!foundFilialId && parentGeo?.filialId) {
                            foundFilialId = parentGeo.filialId
                        }
                    }
                    // Загружаем данные филиала по найденному filialId
                    if (foundFilialId) {
                        setGeoFilialId(foundFilialId)
                        // Сначала ищем в уже загруженном списке (не требует доступа к API)
                        const foundInList = filialsLoaded.find(f => f.id === foundFilialId)
                        if (foundInList?.name) {
                            setGeoFilialName(foundInList.name)
                        } else {
                            // Если не нашли в списке — пробуем загрузить через API
                            try {
                                const filialData = await filialCRUD.get(foundFilialId)
                                if (filialData?.name) {
                                    setGeoFilialName(filialData.name)
                                }
                            } catch (e) {
                                // Клиент не имеет доступа к filialCRUD — игнорируем
                            }
                        }
                    }
                }
            } catch (e) {
                console.error("Ошибка загрузки гео-данных:", e)
            }
            setRegionLoading(false)

            dispatch({type: LOADING_FALSE})
        }())
    }, [dispatch, addressId])

    // Показываем диалог подтверждения региона при загрузке, если корзина не пуста
    useEffect(() => {
        if (!regionLoading && basket?.length > 0 && !regionConfirmed) {
            setRegionDialogOpen(true)
        }
    }, [regionLoading, basket, regionConfirmed])

    const handleRegionYes = () => {
        // Пользователь подтвердил свой регион — ищем подходящий филиал
        let found = false

        // 1. Филиал из гео-объекта пользователя (самый надёжный способ)
        if (geoFilialId) {
            setSelectedFilial(geoFilialId)
            found = true
        }
        // 2. Филиал из Redux (filialUser)
        if (!found && filialUser?.id) {
            setSelectedFilial(filialUser.id)
            found = true
        }
        // 3. Поиск филиала по addressId пользователя
        if (!found && addressId && filials.length > 0) {
            const matchedFilial = filials.find(f => f.addressId === addressId)
            if (matchedFilial) {
                setSelectedFilial(matchedFilial.id)
                found = true
            }
        }
        setRegionConfirmed(true)
        setRegionDialogOpen(false)
    }

    const handleRegionNo = () => {
        // Пользователь не в своём регионе — пусть выберет филиал вручную из dropdown
        setSelectedFilial('')
        setRegionConfirmed(true)
        setRegionDialogOpen(false)
    }

    useEffect(() => {
        setPrice(basketLocal.reduce((acc, curr) => {
            return acc + (curr.price * curr.qty);
        }, 0))
    }, [basketLocal]);

    const setBasketHandle = async (event) => {
        setBasketLocal(event)
        await dispatch(changeBasket(event))
    }

    useEffect(() => {
        if (basket) {
            setBasketLocal([...basket])
        }
    }, [basket])

    const handleConfirmClientRequest = async () => {
        if (!selectedFilial) {
            dispatch(showSuccessSnackbar("Выберите филиал перед оформлением заявки", "error"))
            return
        }
        try {
            const specification = basketLocal.map(el => ({
                price: el.price,
                count: el.qty,
                summary: el.summary,
                serviceId: el.id,
                scheduleId: el.scheduleId
            }))
            const specificationsSummary = specification.reduce((acc, curr) => {
                return acc + curr.summary;
            }, 0)
            
            // Определяем cityId: для ЦА (название не начинается с "Филиал") НЕ отправляем cityId,
            // чтобы заявка шла именно в центральную организацию. Для региональных филиалов — используем их addressId.
            const selectedFilialData = filials.find(f => f.id === selectedFilial)
            console.log("Выбранный филиал:", JSON.stringify(selectedFilialData, null, 2))
            const isCentralOrg = selectedFilialData && !selectedFilialData.name?.toLowerCase().startsWith('филиал')
            const cityIdForRequest = isCentralOrg ? null : (selectedFilialData?.addressId || null)
            await dispatch(addClientRequest(specification, profile?.client?.id, cityIdForRequest, specificationsSummary, selectedFilial))
            setBasketLocal([])
            dispatch(clearBasket())
            
            // Показываем уведомление в центре экрана
            setNotificationMessage("Заявка успешно оформлена! Переходим к истории заявок...")
            setNotificationSeverity("success")
            setNotificationOpen(true)
            
            // Перенаправляем в историю заявок через 3 секунды
            setTimeout(() => {
                history.push(GENERAL_ROUTE + '/history')
            }, 3000)
        } catch (error) {
            const errorDetail = error?.response?.data?.errors 
                ? JSON.stringify(error.response.data.errors) 
                : (error?.response?.data?.message || error?.message || '')
            setNotificationMessage(`Ошибка при оформлении заявки: ${errorDetail}`)
            setNotificationSeverity("error")
            setNotificationOpen(true)
        }
    }

    return (
        <>
            {!isClient && <DashboardLayout>
                <BreadcrumbsShared breadcrumbs={[
                    {text: 'Главная', link: GENERAL_ROUTE},
                    {text: 'Корзина', link: GENERAL_ROUTE + `/basket`},
                ]}/>
                <Box sx={{display: 'flex', gap: 2}}>
                    <Paper sx={{flex: '1 1 auto', minWidth: 0, overflow: 'auto'}}>
                        {basketLocal &&
                        <GeneralTable basket dispatch={dispatch} servicesSchedule={servicesSchedule}
                                      setService={setBasketHandle} service={basketLocal} servicePackage={basketLocal}/>
                        }
                    </Paper>
                    <Card sx={{flex: '0 0 280px', alignSelf: 'flex-start'}}>
                        <CardContent>
                            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom variant="body2">
                                Общая стоимость: {price}
                            </Typography>
                            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom variant="body2">
                                Количество исследований: {basketLocal?.length || 0}
                            </Typography>
                            {selectedFilial ? (
                                <Box sx={{mt: 2, p: 1.5, bgcolor: '#e8f5e9', borderRadius: 1}}>
                                    <Typography variant="body2" color="success.main" sx={{fontWeight: 'bold'}}>
                                        <LocationOnIcon sx={{fontSize: 16, verticalAlign: 'middle', mr: 0.5}}/>
                                        Филиал: {filials.find(f => f.id === selectedFilial)?.name || geoFilialName || filialUser?.name || '—'}
                                    </Typography>
                                    <Button size="small" sx={{mt: 1}} onClick={() => setSelectedFilial('')}>Изменить филиал</Button>
                                </Box>
                            ) : (
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Филиал *"
                                    value={selectedFilial}
                                    onChange={(e) => setSelectedFilial(e.target.value)}
                                    sx={{mt: 2}}
                                    helperText="Выберите филиал для заявки"
                                >
                                    {filials.map(f => (
                                        <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>
                                    ))}
                                </TextField>
                            )}
                        </CardContent>
                        <CardActions>
                            <Button disabled={!basket?.length} onClick={() => setOpen(true)} size="small"
                                    variant="outlined"
                                    startIcon={<ShopIcon/>}>Получить договор</Button>
                        </CardActions>
                    </Card>
                </Box>
                <Button
                    disabled={!basket?.length}
                    onClick={() => confirmDialog('Удаление элемента', 'Вы действительно хотите очистить корзину?', () => {
                        setBasketLocal([])
                        return dispatch(clearBasket())
                    })} sx={{marginTop: 3}} size="small" variant="outlined" startIcon={<HighlightOffIcon/>}>Очистить
                    корзину</Button>
                <Button disabled={!basket?.length} onClick={handleConfirmClientRequest} startIcon={<RecommendIcon/>}
                        sx={{marginTop: 3, marginLeft: 2}} size="small" variant="outlined">Оформить заявку</Button>
            </DashboardLayout>}
            {isClient && <ClientLayout>
                <BreadcrumbsShared breadcrumbs={[
                    {text: 'Главная', link: GENERAL_ROUTE},
                    {text: 'Корзина', link: GENERAL_ROUTE + `/basket`},
                ]}/>
                <Box sx={{display: 'flex', gap: 2}}>
                    <Paper sx={{flex: '1 1 auto', minWidth: 0, overflow: 'auto'}}>
                        {basketLocal &&
                        <GeneralTable basket dispatch={dispatch} servicesSchedule={servicesSchedule}
                                      setService={setBasketHandle} service={basketLocal} servicePackage={basketLocal}/>
                        }
                    </Paper>
                    <Card sx={{flex: '0 0 280px', alignSelf: 'flex-start'}}>
                        <CardContent>
                            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom variant="body2">
                                Общая стоимость: {price}
                            </Typography>
                            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom variant="body2">
                                Количество исследований: {basketLocal?.length || 0}
                            </Typography>
                            {selectedFilial ? (
                                <Box sx={{mt: 2, p: 1.5, bgcolor: '#e8f5e9', borderRadius: 1}}>
                                    <Typography variant="body2" color="success.main" sx={{fontWeight: 'bold'}}>
                                        <LocationOnIcon sx={{fontSize: 16, verticalAlign: 'middle', mr: 0.5}}/>
                                        Филиал: {filials.find(f => f.id === selectedFilial)?.name || geoFilialName || filialUser?.name || '—'}
                                    </Typography>
                                    <Button size="small" sx={{mt: 1}} onClick={() => setSelectedFilial('')}>Изменить филиал</Button>
                                </Box>
                            ) : (
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Филиал *"
                                    value={selectedFilial}
                                    onChange={(e) => setSelectedFilial(e.target.value)}
                                    sx={{mt: 2}}
                                    helperText="Выберите филиал для заявки"
                                >
                                    {filials.map(f => (
                                        <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>
                                    ))}
                                </TextField>
                            )}
                        </CardContent>
                        <CardActions>
                            <Button disabled={!basket?.length} onClick={() => setOpen(true)} size="small"
                                    variant="outlined"
                                    startIcon={<ShopIcon/>}>Получить договор</Button>
                        </CardActions>
                    </Card>
                </Box>
                <Button
                    disabled={!basket?.length}
                    onClick={() => confirmDialog('Удаление элемента', 'Вы действительно хотите очистить корзину?', () => {
                        setBasketLocal([])
                        return dispatch(clearBasket())
                    })} sx={{marginTop: 3}} size="small" variant="outlined" startIcon={<HighlightOffIcon/>}>Очистить
                    корзину</Button>
                <Button disabled={!basket?.length} onClick={handleConfirmClientRequest} startIcon={<RecommendIcon/>}
                        sx={{marginTop: 3, marginLeft: 2}} size="small" variant="outlined">Оформить заявку</Button>
            </ClientLayout>}
            <PopupPreliminarilyContract open={open} handleClose={handleClose}/>

            {/* Диалог подтверждения региона */}
            <Dialog
                open={regionDialogOpen}
                maxWidth="sm"
                fullWidth
                disableEscapeKeyDown
            >
                <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold', pt: 3}}>
                    <LocationOnIcon sx={{fontSize: 40, color: 'primary.main', mb: 1}} /><br/>
                    Вы находитесь в этом регионе?
                </DialogTitle>
                <DialogContent sx={{textAlign: 'center', pb: 1}}>
                    {regionLoading ? (
                        <CircularProgress size={30} />
                    ) : (
                        <Box sx={{mt: 1}}>
                            {regionName && (
                                <Typography variant="body1" color="text.secondary" sx={{mb: 0.5}}>
                                    Регион: {regionName}
                                </Typography>
                            )}
                            <Typography variant="h6" sx={{fontWeight: 'bold', mb: 1}}>
                                {cityName || 'Город не определён'}
                            </Typography>
                            {(geoFilialName || filialUser?.name) && (
                                <Typography variant="body1" color="text.secondary">
                                    Филиал: {geoFilialName || filialUser.name}
                                </Typography>
                            )}
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{justifyContent: 'center', pb: 3, gap: 2}}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={handleRegionYes}
                        disabled={regionLoading}
                        sx={{minWidth: 120}}
                    >
                        Да
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        size="large"
                        onClick={handleRegionNo}
                        disabled={regionLoading}
                        sx={{minWidth: 120}}
                    >
                        Нет
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Кастомное уведомление в центре экрана */}
            <Snackbar
                open={notificationOpen}
                autoHideDuration={3000}
                onClose={() => setNotificationOpen(false)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                sx={{
                    '& .MuiSnackbarContent-root': {
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                }}
            >
                <Alert 
                    onClose={() => setNotificationOpen(false)} 
                    severity={notificationSeverity}
                    variant="filled"
                    sx={{ 
                        width: '100%',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        minWidth: '300px'
                    }}
                >
                    {notificationMessage}
                </Alert>
            </Snackbar>
        </>
    );
}

export default Basket;